import t from "react";
import { c, t as s } from "./app-a75c1d35.mjs";
import { B as i } from "./Block-9b78bd10.mjs";
import { L as l } from "./Link-479ac100.mjs";
import { I as f, W as d } from "./Icon-3122c134.mjs";
import "./LinkContext-0c83848a.mjs";
const _ = "footer", u = "footer__logo", T = "desktop", h = "footer__button-to-top", C = "footer__button-to-top__btn-text", L = "footer__content_list", x = "footer__content_list--item", g = "footer__content_list__link", E = "footer__icon-content", y = "footer__icon-content__header", B = "footer__icon-content__list", I = "footer__copyright", b = "footer__copyright--text", N = "mobile--text", o = {
  footer: _,
  footerLogo: u,
  desktop: T,
  footerButtonToTop: h,
  footerButtonToTopBtnText: C,
  footerContentList: L,
  footerContentListItem: x,
  footerContentListLink: g,
  footerIconContent: E,
  footerIconContentHeader: y,
  footerIconContentList: B,
  footerCopyright: I,
  footerCopyrightText: b,
  mobileText: N
};
function m({
  logo: n,
  ctaExternalLink: r,
  children: e,
  backToTopLabel: a
}) {
  return /* @__PURE__ */ t.createElement(i, { as: "footer", className: o.footer, "data-testid": "footer-block" }, /* @__PURE__ */ t.createElement(i.Content, { "data-testid": "footer-block-content" }, /* @__PURE__ */ t.createElement(
    "div",
    {
      role: "presentation",
      className: o.footerLogo,
      "data-testid": "footer-logo"
    },
    n
  ), /* @__PURE__ */ t.createElement(
    F,
    {
      "data-testid": "footer-to-top-button",
      backToTopLabel: a
    }
  ), e, /* @__PURE__ */ t.createElement("div", { className: o.footerCopyright, "data-testid": "footer-copy-right" }, r, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: c(
        s.textsBodyText,
        o.footerCopyrightText
      )
    },
    /* @__PURE__ */ t.createElement("span", { "data-testid": "copyright-text" }, "© WorkInFinland.com ", (/* @__PURE__ */ new Date()).getFullYear())
  ))));
}
m.LinkList = k;
m.IconList = v;
function k({
  links: n,
  boldText: r = !1
}) {
  return !n || n.length === 0 ? null : /* @__PURE__ */ t.createElement(
    "ul",
    {
      className: o.footerContentList,
      "data-testid": "footer-list-container",
      itemScope: !0,
      itemType: "https://schema.org/ItemList"
    },
    n.map((e, a) => {
      if (!e.href)
        return null;
      const p = e.href.includes("://");
      return e.href ? /* @__PURE__ */ t.createElement(
        "li",
        {
          className: o.footerContentListItem,
          key: e.id,
          "data-testid": `footer-link-${e.id}`,
          itemProp: "itemListElement",
          itemScope: !0,
          itemType: "https://schema.org/ListItem"
        },
        /* @__PURE__ */ t.createElement("meta", { itemProp: "position", content: String(a + 1) }),
        /* @__PURE__ */ t.createElement(
          l,
          {
            href: e.href,
            target: p ? "_blank" : void 0,
            locale: e.locale,
            className: c(
              r ? s.textsBodyTextBold : s.textsBodyText,
              o.footerContentListLink
            ),
            itemProp: "item"
          },
          e.title
        )
      ) : null;
    })
  );
}
function v({
  iconLinks: n,
  followUsLabel: r = "Follow us"
}) {
  return !n || n.length === 0 ? null : /* @__PURE__ */ t.createElement("div", { className: o.footerIconContent }, /* @__PURE__ */ t.createElement("div", { className: o.footerIconContentHeader }, /* @__PURE__ */ t.createElement("span", { className: s.textsBodyTextBold }, r)), /* @__PURE__ */ t.createElement(
    "div",
    {
      className: o.footerIconContentList,
      "data-testid": "footer-list-container"
    },
    n.map((e, a) => /* @__PURE__ */ t.createElement(
      l,
      {
        "data-testid": `footer-icon-${a}`,
        key: e.url,
        href: e.url,
        target: "_blank",
        rel: "noreferrer noopener",
        "aria-label": e.label
      },
      /* @__PURE__ */ t.createElement(f, { ...e })
    ))
  ));
}
function F({
  backToTopLabel: n = "Back to Top"
}) {
  const r = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      className: c(s.textsBodyText, o.footerButtonToTop),
      onClick: r
    },
    /* @__PURE__ */ t.createElement("div", { className: o.footerButtonToTopBtnText }, /* @__PURE__ */ t.createElement("span", null, n)),
    /* @__PURE__ */ t.createElement(f, { icon: d.CHEVRON_UP, size: 16, color: "white" })
  );
}
export {
  m as Footer
};
//# sourceMappingURL=Footer.js.map
